module.exports = __webpack_public_path__ + "img/06_BetonsarkophagRost_iPad_L.3890f62f.jpg";